
import { IScheduleCreate } from '@/interfaces/schedule';
import { adminStore, departureStore, mainStore, scheduleStore, userActionStore } from '@/store';
import { format, parse } from 'date-fns';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ScheduleForm extends Vue {
  @Prop({ type: Boolean, default: false }) dialogVisible!: boolean;
  @Prop({ type: Boolean, default: false }) isLead?: boolean;
  @Prop({ type: Number || null, default: null }) leadId?: number;
  @Prop({ type: String, default: '' }) descricaoDefault?: string;
  @Prop({ type: String, default: '' }) tituloDefault?: string;
  @Prop({ type: String, default: '' }) linkDefault?: string;

  name: string = '';
  error: boolean = false;
  description: string = '';
  responsibleUserId: number | null = null;
  participantUserIds: number[] = [];
  link: string = '';
  departureId: number | null = null;
  date: string = '';
  Hora: string = '';
  horaFinal: string = '';
  dateFinal: string = ''; // Nova variável
  conflictMessage: string = '';
  statusId: string = 'Agendado';
  loading: boolean = false;
  dialogVisible2: boolean = false;
  isResponsibleReadonly: Boolean = false;
  menuTime: Boolean = false;
  conflictDialog: boolean = false;
  menuDate: Boolean = false;
  menuTimeFinal: Boolean = false; // Novo menu para Data Final
  get idFranchising() {
    return this.currentUser!.franchising_id;
  }

  // Watchers para tornar as props reativas
  @Watch('tituloDefault', { immediate: true })
  onTituloDefaultChange(newVal: string) {
    this.name = newVal;
  }

  @Watch('linkDefault', { immediate: true })
  onLinkDefaultChange(newVal: string) {
    this.link = newVal;
  }

  get formattedDate(): string {
    return this.date ? format(parse(this.date, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy') : '';
  }

  set formattedDate(value: string) {
    const parsedDate = parse(value, 'dd/MM/yyyy', new Date());
    this.date = format(parsedDate, 'yyyy-MM-dd');
  }

  get departures() {
    return departureStore.departures;
  }

  @Watch('dialogVisible')
  async onDialogVisible(newValue) {
    this.dialogVisible2 = true;
  }

  get minDateTime() {
    const now = new Date();
    return format(now, "yyyy-MM-dd'T'HH:mm");
  }

  get currentUser() {
    return mainStore.userProfile!;
  }

  async mounted() {
    await adminStore.getUsersBasic({ is_active: true });
    this.departureId = this.currentUser.departure_id;
    this.idFranchising = this.currentUser?.franchising_id;

    if (this.isLead) {
      this.description = this.descricaoDefault;
      this.name = this.tituloDefault;
      this.link = this.linkDefault;
    }

    const searchParams = {
      idFranchising: this.idFranchising,
      is_active: true,
    };

    await adminStore.getUsers({
      searchParams: searchParams,
    });
  }

  get participantes() {
    return adminStore.users;
  }

  get podeAtribuirResponsavel() {
    return userActionStore.AtribuirResponsavelSchedule;
  }

  get responsibleOptions() {
    // Se o usuário não pode atribuir responsável e não tem role_id 1, ele próprio é o responsável
    if (this.currentUser?.role?.level !== 1 && !this.podeAtribuirResponsavel) {
      this.responsibleUserId = this.currentUser.id;
      this.isResponsibleReadonly = true;
      return [this.currentUser];
    } else {
      // Garante que usersOptions seja um array antes de filtrar
      const users = adminStore.usersFranchising;

      // Retorna apenas usuários do mesmo departamento
      return users.filter((user) => user.departure_id === this.currentUser.departure_id);
    }
  }

  async submitForm() {
    this.loading = true;

    const formatDateTime = (date: string, time: string): string => {
      return `${date} ${time}:00`;
    };

    const dateHoraString = formatDateTime(this.date, this.Hora);
    const dateFinalString = this.horaFinal ? formatDateTime(this.date, this.horaFinal) : null;

    try {
      // Verifica se já existe um evento marcado para o mesmo horário
      const hasConflict = await this.checkScheduleConflict(dateHoraString, dateFinalString);

      if (hasConflict) {
        this.conflictMessage = 'O responsável já tem um evento marcado nesse horário!';
        this.conflictDialog = true;
        this.loading = false;
        return;
      }

      const scheduleData: IScheduleCreate = {
        name: this.name,
        description: this.description,
        link: this.link,
        departure_id: this.currentUser.departure_id,
        date: dateHoraString,
        date_final: dateFinalString,
        status_id: 1,
        created_by_user_id: this.currentUser.id,
        participants_user_id: this.participantUserIds,
        responsible_user_id: this.responsibleUserId,
        lead_id: this.leadId || undefined,
      };

      await scheduleStore.createSchedule(scheduleData);
      this.clearForm();
      this.dialogVisible2 = false;
      this.$emit('carregarEventosNovosOuAtualizados');
    } catch (error) {
      console.error('Erro ao criar evento:', error);
    } finally {
      this.loading = false;
    }
  }

  clearForm() {
    this.name = '';
    this.description = '';
    this.responsibleUserId = null;
    this.participantUserIds = [];
    this.link = '';
    this.date = '';
    this.Hora = '';
    this.dateFinal = '';
    this.horaFinal = ''; // Resetando a nova variável
  }

  async checkScheduleConflict(startDate: string, endDate: string | null) {
    if (!this.responsibleUserId) return false;

    // Buscar eventos já agendados do responsável
    const events = await scheduleStore.getSchedulesByUser(this.responsibleUserId);

    return events.some((event) => {
      const eventStart = new Date(event.date);
      const eventEnd = event.date_final ? new Date(event.date_final) : eventStart;

      // Verifica se há sobreposição de horários
      return (
        new Date(startDate) < eventEnd && (endDate ? new Date(endDate) > eventStart : new Date(startDate) >= eventStart)
      );
    });
  }
}
